




import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class NormalButton extends Vue {
  @Prop({})
  private name!: string;
  @Prop({default: false})
  private disabled!: boolean;

  @Emit('click')
  private doClick(): void {
    return;
  }
}
